import { EditableComponent } from '@adobe/aem-react-editable-components';
import React from 'react';
import { StyledStaticDestinationTable } from './StaticDestinationTableAuthoring.styles';

type PropertyDetail = {
  propertyName: string;
  searchKeyword: string;
  marshaCode: string;
};

type Destination = {
  propertyDetails?: PropertyDetail[];
  metroArea: string;
};

type Props = {
  model?: {
    destinations?: Destination[];
  };
};

const StaticDestinationTable: React.FC<Props> = props => {
  const destinations = props?.model?.destinations ?? [];

  if (!destinations.length) {
    return (
      <StyledStaticDestinationTable>
        <p className="empty">No destinations available.</p>
      </StyledStaticDestinationTable>
    );
  }

  return (
    <StyledStaticDestinationTable>
      {destinations.map((destination, destIndex) => {
        const properties = destination?.propertyDetails ?? [];
        return (
          <section key={`metro-${destIndex}`} className="section">
            <header className="header">
              <h3 className="metro-title">Metropolitan area: {destination?.metroArea || 'Unknown Metro Area'}</h3>
              <p className="meta">
                {properties.length} {properties.length === 1 ? 'property' : 'properties'}
              </p>
            </header>

            <div className="table-scroll">
              <table className="table" role="table">
                {/* Shared column widths across all tables */}
                <colgroup>
                  <col className="col-prop" /> {/* Property Name */}
                  <col className="col-code" /> {/* MARSHA Code */}
                  <col className="col-search" /> {/* Search Keyword */}
                </colgroup>

                <thead className="thead">
                  <tr>
                    <th scope="col">Property Name</th>
                    <th scope="col">MARSHA Code</th>
                    <th scope="col">Search Keyword</th>
                  </tr>
                </thead>

                <tbody className="tbody">
                  {properties.length > 0 ? (
                    properties.map((property, propIndex) => (
                      <tr key={`prop-${propIndex}-${property?.marshaCode ?? 'no-code'}`}>
                        <td title={property?.propertyName || '-'}>{property?.propertyName || '-'}</td>
                        <td>
                          <code className="code" title={property?.marshaCode || '-'}>
                            {property?.marshaCode || '-'}
                          </code>
                        </td>
                        <td title={property?.searchKeyword || '-'}>{property?.searchKeyword || '-'}</td>
                      </tr>
                    ))
                  ) : (
                    <tr className="empty-row">
                      <td colSpan={3}>No property details available.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </section>
        );
      })}
    </StyledStaticDestinationTable>
  );
};

const StaticDestinationTableConfig = {
  emptyLabel: 'Static Destination Table',
  isEmpty: () => true,
  resourceType: 'mi-aem-luxury-spa/components/content/staticdestinations/v1/staticdestinations',
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const StaticDestinationTableAuthoring = (props: any) => (
  <EditableComponent config={StaticDestinationTableConfig} {...props}>
    <StaticDestinationTable {...props} />
  </EditableComponent>
);

export default StaticDestinationTableAuthoring;
